import { Link } from 'react-router-dom';

export type DoctorCardData = {
  id: number;
  name: string;
  title: string;
  hospital: string;
  tags: string[];
  intro: string;
  avatar: string;
};

type DoctorCardProps = {
  doctor: DoctorCardData;
  showAction?: boolean;
  /** 医师库暂无该医师时传 false：卡片仅静态展示，不可跳转详情页 */
  linkable?: boolean;
};

export default function DoctorCard({ doctor, showAction = true, linkable = true }: DoctorCardProps) {
  const className = `group flex flex-col items-center text-center h-full p-6 rounded-lg bg-background-50 border border-background-200 transition-colors ${
    linkable ? 'hover:border-primary-300 cursor-pointer' : ''
  }`;

  const content = (
    <>
      <div className="w-24 h-24 rounded-full overflow-hidden mb-4 border-4 border-background-100 group-hover:border-primary-100 transition-colors bg-background-100">
        {doctor.avatar ? (
          <img
            src={doctor.avatar}
            alt={doctor.name}
            title={`${doctor.name} - ${doctor.title}`}
            className="w-full h-full object-cover object-top"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-foreground-400">
            <i className="ri-user-3-line text-4xl"></i>
          </div>
        )}
      </div>
      <h3 className="font-heading font-bold text-lg text-foreground-900">{doctor.name}</h3>
      <p className="text-xs text-primary-600 font-medium mt-1">{doctor.title}</p>
      <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{doctor.hospital}</p>

      {doctor.tags.length > 0 && (
        <div className="flex flex-wrap items-center justify-center gap-2 mt-4">
          {doctor.tags.map((tag) => (
            <span key={tag} className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs">
              {tag}
            </span>
          ))}
        </div>
      )}

      {doctor.intro && (
        <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3 mt-4">{doctor.intro}</p>
      )}

      {showAction && linkable && (
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
          查看主页
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </span>
      )}
    </>
  );

  if (!linkable) {
    return <div className={className}>{content}</div>;
  }

  return (
    <Link to={`/doctors/${doctor.id}`} className={className}>
      {content}
    </Link>
  );
}